<template>
<!--    <div>-->
<!--        <div style="padding-bottom: 100px;"><router-view :key="$route.fullPath" @bgColor="bgColor"/></div>-->
<!--        <van-tabbar route safe-area-inset-bottom>-->
<!--            <van-tabbar-item name="/" :to="{path:'/',query:{rss2:rss2}}" icon="wap-home-o">首页</van-tabbar-item>-->
<!--            <van-tabbar-item name="home" :to="{path:'/home',query:{rss2:rss2}}" icon="todo-list-o">招标订阅</van-tabbar-item>-->
<!--            <van-tabbar-item name="search" :to="{path:'/search',query:{rss2:rss2}}" icon="search">搜索</van-tabbar-item>-->
<!--            <van-tabbar-item name="me" :to="{path:'/me',query:{rss2:rss2}}" icon="user-o">个人中心</van-tabbar-item>-->
<!--        </van-tabbar>-->
<!--    </div>-->
	<div class="text-center">
		<div class="dark-2 f14" style="margin-top:50px;">请长按下面的二维码，进入小程序</div>
		<div class="margin-top">
			<img :src="weixin_mini_app_qrcode"/>
		</div>
	</div>
</template>

<script>
export default {
    name: 'Home',
    data(){
        return{
            rss2:'',
	        weixin_mini_app_qrcode:''
        }
    },
    created() {
        this.rss2 = this.$route.query.rss2 ? this.$route.query.rss2 : '';
				this.getSystem();
    },
    methods:{
        bgColor(event){
            document.querySelector('body').style.backgroundColor = event;
        },
	    getSystem(){
					let _this = this;
		
		    this.$http.post({
			    url: 'SystemSetting/getSystem',
			    data: {skey:'weixin_mini_app_qrcode'},
			    success(res) {
						console.log(res);
						_this.weixin_mini_app_qrcode = res.weixin_mini_app_qrcode.indexOf('http') >= 0 ? res.weixin_mini_app_qrcode : _this.$config.assetsUrl + res.weixin_mini_app_qrcode;
			    }
		    })
	    }
    }
}
</script>
